import { MicrophoneIcon } from '@heroicons/react/outline'
import classNames from 'classnames'
import React from 'react'
import Image from 'shared/components/base/image/Image'

export type operatorWithRequested = {
  name?: string
  position?: string
  imageUrl?: string
  isBusy: boolean
  requests?: {
    name?: string
    quantity?: string
  }[]
  isDrawerOpen?: boolean
}

// --------------------classNames-----------------------
const parentClassName = '!w-[100%] flex flex-col justify-center items-center  '
const imageClassName = 'w-[36px] h-[36px] rounded-full mb-2 '
const nameClassName =
  ' w-content   text-center  truncate relative font-medium text-[13px] leading-[22px] text-title-gray '
const positionClassName =
  'text-center font-normal text-[11px] leading-[25px] text-light-gray '
const badgeClassName =
  '  w-content !px-2 my-auto text-center truncate relative  rounded-[10px] bg-chinese-white2 text-color-title '
const quantityClassName =
  'hidden xl:block  font-normal text-[10px] leading-[23px]  text-title-gray'
// --------------------end classNames-----------------------

export const Operator = (props: operatorWithRequested) => {
  const { imageUrl, requests, position, name, isBusy, isDrawerOpen } = props

  return (
    <div className={parentClassName}>
      <div>
        <Image src={imageUrl || ''} className={imageClassName} />
        {/*------------------------------ if operator is talking , show mic svg near his profile ------------------------------*/}
        {isBusy && (
          <div
            className={
              ' w-[18px] h-[18px] rounded-full -translate-y-[25px] translate-x-[5px]  xl:-translate-y-[25px] xl:translate-x-[10px] absolute p-[2.5px] bg-green-cta'
            }
          >
            <MicrophoneIcon className={'text-white '} />
          </div>
        )}
        {/*--------------------------------------------end mic svg ------------------------------*/}
      </div>
      {/*------------------------------------   name & position ----------------------------*/}
      <div className={'w-[100%]'}>
        <div
          className={classNames(
            ' flex justify-center flex-col px-2 overflow-clip mt-1'
          )}
        >
          <div className={nameClassName}>{name}</div>
          <div
            className={classNames(
              positionClassName,
              'hidden xl:!block',
              `${isDrawerOpen ? '!block' : 'hidden'}`
            )}
          >
            {position}
          </div>
        </div>
      </div>
      {/*------------------------------------ end name & position ----------------------------*/}

      {/*----------------------------------requested products & quantity's -------------------------*/}
      {
        <div className={'space-y-[10px] w-[100%] '}>
          {requests?.map((req, index) => {
            return (
              <>
                <div
                  key={index}
                  className={
                    ' flex justify-center  px-[2px] overflow-clip mt-1'
                  }
                >
                  <div
                    className={classNames(
                      badgeClassName,
                      `${
                        isDrawerOpen
                          ? 'text-[13px] font-medium leading-[22px] !py-1 '
                          : 'text-[12px] font-normal leading-[30px] '
                      }`
                    )}
                  >
                    {req?.name}
                  </div>
                </div>
                <div className={classNames(quantityClassName, ' text-center')}>
                  <span className={'relative mx-auto'}>{req?.quantity}</span>
                </div>
              </>
            )
          })}
        </div>
      }
      {/*---------------------------------- end requested products & quantity's -------------------------*/}
    </div>
  )
}
